// Shared default configuration constants.
// Kept here (not in pages/Settings.js) so non-page modules (context, hooks)
// can import them without pulling in the entire Settings page bundle.

export const DEFAULT_CURRENCY_SETTINGS = {
  baseCurrency: 'NGN',
  currencies: [
    { code: 'USD', name: 'US Dollar',          symbol: '$',    isActive: true,  rateToUsd: 1.0    },
    { code: 'EUR', name: 'Euro',               symbol: '€',    isActive: true,  rateToUsd: 0.92   },
    { code: 'GBP', name: 'British Pound',      symbol: '£',    isActive: true,  rateToUsd: 0.79   },
    { code: 'NGN', name: 'Nigerian Naira',     symbol: '₦',    isActive: true,  rateToUsd: 1500.0 },
    { code: 'GHS', name: 'Ghanaian Cedi',      symbol: 'GH₵',  isActive: false, rateToUsd: 12.5   },
    { code: 'KES', name: 'Kenyan Shilling',    symbol: 'KSh',  isActive: false, rateToUsd: 130.0  },
    { code: 'ZAR', name: 'South African Rand', symbol: 'R',    isActive: false, rateToUsd: 18.8   },
    { code: 'EGP', name: 'Egyptian Pound',     symbol: 'E£',   isActive: false, rateToUsd: 48.0   },
    { code: 'AED', name: 'UAE Dirham',         symbol: 'د.إ',  isActive: false, rateToUsd: 3.67   },
    { code: 'SAR', name: 'Saudi Riyal',        symbol: '﷼',    isActive: false, rateToUsd: 3.75   },
    { code: 'INR', name: 'Indian Rupee',       symbol: '₹',    isActive: false, rateToUsd: 83.0   },
    { code: 'CNY', name: 'Chinese Yuan',       symbol: '¥',    isActive: false, rateToUsd: 7.24   },
    { code: 'JPY', name: 'Japanese Yen',       symbol: '¥',    isActive: false, rateToUsd: 149.0  },
    { code: 'CAD', name: 'Canadian Dollar',    symbol: 'CA$',  isActive: false, rateToUsd: 1.36   },
    { code: 'AUD', name: 'Australian Dollar',  symbol: 'A$',   isActive: false, rateToUsd: 1.54   },
    { code: 'CHF', name: 'Swiss Franc',        symbol: 'Fr',   isActive: false, rateToUsd: 0.90   },
    { code: 'BRL', name: 'Brazilian Real',     symbol: 'R$',   isActive: false, rateToUsd: 4.97   },
    { code: 'MXN', name: 'Mexican Peso',       symbol: 'MX$',  isActive: false, rateToUsd: 17.1   },
    { code: 'SGD', name: 'Singapore Dollar',   symbol: 'S$',   isActive: false, rateToUsd: 1.34   },
    { code: 'HKD', name: 'Hong Kong Dollar',   symbol: 'HK$',  isActive: false, rateToUsd: 7.82   },
    { code: 'NOK', name: 'Norwegian Krone',    symbol: 'kr',   isActive: false, rateToUsd: 10.5   },
    { code: 'SEK', name: 'Swedish Krona',      symbol: 'kr',   isActive: false, rateToUsd: 10.4   },
    { code: 'DKK', name: 'Danish Krone',       symbol: 'kr',   isActive: false, rateToUsd: 6.88   },
    { code: 'PLN', name: 'Polish Zloty',       symbol: 'zł',   isActive: false, rateToUsd: 3.94   },
    { code: 'TRY', name: 'Turkish Lira',       symbol: '₺',    isActive: false, rateToUsd: 32.0   },
    { code: 'RUB', name: 'Russian Ruble',      symbol: '₽',    isActive: false, rateToUsd: 90.0   },
    { code: 'THB', name: 'Thai Baht',          symbol: '฿',    isActive: false, rateToUsd: 35.1   },
    { code: 'MYR', name: 'Malaysian Ringgit',  symbol: 'RM',   isActive: false, rateToUsd: 4.73   },
    { code: 'IDR', name: 'Indonesian Rupiah',  symbol: 'Rp',   isActive: false, rateToUsd: 15700  },
    { code: 'PHP', name: 'Philippine Peso',    symbol: '₱',    isActive: false, rateToUsd: 56.5   },
    { code: 'PKR', name: 'Pakistani Rupee',    symbol: '₨',    isActive: false, rateToUsd: 278.0  },
    { code: 'BDT', name: 'Bangladeshi Taka',   symbol: '৳',    isActive: false, rateToUsd: 110.0  },
    { code: 'CZK', name: 'Czech Koruna',       symbol: 'Kč',   isActive: false, rateToUsd: 22.8   },
    { code: 'HUF', name: 'Hungarian Forint',   symbol: 'Ft',   isActive: false, rateToUsd: 356.0  },
    { code: 'RON', name: 'Romanian Leu',       symbol: 'lei',  isActive: false, rateToUsd: 4.59   },
    { code: 'ILS', name: 'Israeli Shekel',     symbol: '₪',    isActive: false, rateToUsd: 3.74   },
    { code: 'QAR', name: 'Qatari Riyal',       symbol: 'QR',   isActive: false, rateToUsd: 3.64   },
    { code: 'KWD', name: 'Kuwaiti Dinar',      symbol: 'KD',   isActive: false, rateToUsd: 0.307  },
    { code: 'MAD', name: 'Moroccan Dirham',    symbol: 'د.م.', isActive: false, rateToUsd: 9.98   },
    { code: 'TZS', name: 'Tanzanian Shilling', symbol: 'TSh',  isActive: false, rateToUsd: 2540   },
  ],
};

const EMPTY_TYPE_DEFAULTS = {
  originPlaceId: '', destinationPlaceId: '', driverId: '', vehicleId: '',
  contactId: '', vendorId: '', currency: '', baseAmount: '', totalAmount: '',
  notes: '', trackingNumber: '',
};

export const DEFAULT_ORDER_CONFIG = {
  orderTypes: [
    { id: 1, name: 'Standard', description: '', defaults: { ...EMPTY_TYPE_DEFAULTS } },
  ],
};
